import Cookies from "js-cookie";
import {getDefaultFailureActionReducer} from "./defaultFailureAction";

export function getLoginFailureReducer(state, action) {
	Cookies.remove("mbdo_at");

	return getDefaultFailureActionReducer(state, action);
}
